import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/icons/Link'
import LinksDialog from './LinksDialog';

function Links (props) {

    const [open, setOpen] = useState(false);

    const { insertEntity } = props;

    const openDialog = () => setOpen(true);
    
    const handleClose = () => setOpen(false);

    const handleSubmit = (data) => insertEntity(data, 'LINK');

    return (
        <div>
            <IconButton onClick={openDialog}>
                <Link />
            </IconButton>
            <LinksDialog
                open={open}
                handleSubmit={handleSubmit}
                handleClose={handleClose}
            />
        </div>
    )
}

export default Links
